import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { computeSafeSpawnPosition } from './spawnHelper';

/**
 * Knight (GunBound mobile, Shot 2 - Thor's Hammer). Fires a no-damage tracer;
 * wherever it lands, the satellite high above rains 3 miniature swords down
 * onto the spot (each a strike that craters + damages, blocked by terrain
 * overhead). The swords are called via onProjectileExploded -> queueKnight in
 * Game/HeadlessGame (reusing the generalized Thor-zap machinery).
 */
export const WeaponKnight: WeaponDefinition = {
  id: 'knight',
  name: 'Knight',
  icon: 'knight.png',
  category: 'thrown',
  maxAmmo: 2,
  maxUsesPerTurn: 1,
  powerCharging: true,
  timerAdjustable: false,
  showAimGuide: true,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, angle, power, world } = ctx;

    const speed = (power / 100) * 750;
    const rad = (angle * Math.PI) / 180;
    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;
    const spawn = computeSafeSpawnPosition(worm, aimRad, 20, world);

    // The tracer deals NO damage/crater on contact - the swords (called when
    // it lands, via onProjectileExploded) are the whole payload.
    const tracer = new Projectile({
      x: spawn.x,
      y: spawn.y,
      vx: Math.cos(aimRad) * speed,
      vy: -Math.sin(aimRad) * speed,
      type: 'knight',
      timer: -1,
      windAffected: true,
      ownerId: worm.id,
      noContactExplosion: true,
    });

    return { success: true, entities: [tracer] };
  },
};
